<template>
  <v-row>
    <card-connections-row :cards="cards">
      <template slot="connections-cards" slot-scope="props">
        <card-connections :card-options="props.card"/>
      </template>
    </card-connections-row>

    <!--<v-col cols="12">
        <v-row class="py-2 px-4" justify="space-between" align="center"  >
            <h2 style="display: inline;" id="title">Panel</h2>
            <v-spacer></v-spacer>
            <DateRangePicker class="mr-2" v-model="toolbarDateRangeVisual"></DateRangePicker>
        </v-row>
    </v-col>
-->
    <!--<v-col class="py-4" cols="12" >
      <RegisterCount :statistics=statistics />
    </v-col>-->

    <template v-if="!loadingAppsStatistics">
      <v-col cols="12" md="6">
        <div class="card-chart kbWhite">
          <line-chart style="height: 200px"
                      :chart-data="usersByDay"
                      :options="chartOptions"
                      ref="lineChart1"/>
        </div>
      </v-col>

      <v-col cols="12" md="6">
        <div class="card-chart kbWhite">
          <line-chart style="height: 200px"
                      :chart-data="usersByMonth"
                      :options="chartOptions"
                      ref="lineChart2"/>
        </div>
      </v-col>

      <v-col cols="12">
        <div class="card-chart kbWhite">
          <BarChart style="height: 300px"
                    :chart-data="peopleDetailedInformation"
                    :options="chartOptions"
                    ref="barChart"/>
        </div>
      </v-col>

      <v-col cols="12">
        <div class="card-chart kbWhite">
          <BarChart style="height: 300px"
                    :chart-data="usersPerJourney"
                    :options="chartOptions"
                    ref="barChart"/>
        </div>
      </v-col>
    </template>

    <v-col cols="12">
      <TaskManagement />
    </v-col>

    <v-col cols="12">
      <Likings/>
    </v-col>

    <v-col cols="12" class="py-0">
      <SpotifyTags/>
    </v-col>

    <!--<v-col cols="12" v-if="!loadingAppsStatistics">
      <div class="card-chart">
        <GChart type="GeoChart"
                :data="countriesData"
                :options="countriesOptions"
                :settings="geoChartSettings"/>
      </div>
    </v-col>-->
  </v-row>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
import moment from 'moment'
// Components
import BarChart from '@/components/chart/BarChart'
import CardConnections from '@/components/ui/connections/CardConnections'
import CardConnectionsRow from '@/components/ui/connections/CardConnectionsRow'
import Likings from '@/pages/App/Desktop/Likings.vue'
import LineChart from '@/components/chart/LineChart'
import SpotifyTags from '@/pages/App/Desktop/SpotifyTags'
import TaskManagement from '@/pages/App/Desktop/TaskManagement'

export default {
  components: { BarChart, CardConnections, CardConnectionsRow, Likings, LineChart, SpotifyTags, TaskManagement },
  computed: {
    ...mapState({
      language: state => state.auth.language,
      loadingAppsStatistics: state => state.apps.loadingAppsStatistics,
      selectedApp: state => state.apps.selectedApp,
      statistics: state => state.apps.statistics,
      searchParams: state => state.apps.searchParams,
      toolbarDateRangeVisual: state => state.apps.toolbarDateRangeVisual
    }),
    /* dateTimeText: {
      get () {
        if (!this.toolbarDateRangeVisual.fromDate && !this.toolbarDateRangeVisual.toDate) return ''
        return this.toolbarDateRangeVisual.fromDate + ' - ' + this.toolbarDateRangeVisual.toDate
      },
      set (value) {
        this.$emit('input', { fromDate: this.fromDate, toDate: this.toDate })
      }
    }, */
    cards () {
      // cards:
      if (!this.statistics.count ||
      (this.statistics.count.facebook === undefined && this.statistics.count.instagram === undefined &&
      this.statistics.count.spotify === undefined && this.statistics.count.google === undefined)) return []
      const networkCount = this.statistics.count.facebook + this.statistics.count.instagram +
      this.statistics.count.spotify + this.statistics.count.google
      const total = this.statistics.count.totalUsers
      return [
        {
          title: this.$t('general.socialNetworks'),
          amount: networkCount,
          titleIcon: { icon: 'mdi-circle', color: 'kbLightBlue' }
        },
        {
          title: this.$t('general.sentEmails'),
          amount: this.statistics.count.email || 0,
          titleIcon: { icon: 'email', color: 'email', size: '33px' }
        },
        {
          title: this.$t('general.cellphoneRecords'),
          amount: this.statistics.count.phone || 0,
          titleIcon: { icon: 'smartphone', color: 'phone', size: '33px' }
        },
        {
          title: this.$t('general.totalRecords'),
          amount: total,
          titleIcon: { icon: 'mdi-star', color: 'kbGold', size: '33px' }
        }
      ]
    },
    chartOptions () {
      let options = {
        responsive: true,
        maintainAspectRatio: false
      }
      const darkThemeOptions = {
        legend: {
          labels: {
            fontColor: '#c4c4c4'
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              color: '#14192A'
            },
            ticks: {
              fontColor: '#c4c4c4'
            }
          }],
          xAxes: [{
            gridLines: {
              color: '#14192A'
            },
            ticks: {
              fontColor: '#c4c4c4'
            }
          }]
        }
      }
      if (this.$vuetify.theme.isDark) {
        options = { ...options, ...darkThemeOptions }
      }
      return options
    },
    peopleDetailedInformation () {
      const peopleDetailedInformation = {
        labels: [],
        values: []
      }
      const { count = {} } = this.statistics
      if (
        !this.wereStatisticsFound ||
        !count ||
        !Object.keys(count).length
      ) return peopleDetailedInformation

      const filteringConditions = [
        'smsNumparts',
        'smsRejected',
        'smsSent',
        'total',
        'totalActive',
        'totalImported',
        'totalUnActive',
        'totalUsers'
      ]

      const countKeys = Object.keys(count).filter(item => !filteringConditions.includes(item))

      peopleDetailedInformation.labels = countKeys.map(label => label.toUpperCase())
      peopleDetailedInformation.values = countKeys.map(key => count[key])

      const datasets = [{
        /* backgroundColor: 'rgba(45, 206, 152, 0.3)',
        borderColor: '#2DCE98', */
        backgroundColor: '#4279D6',
        borderColor: 'rgb(0,90,221)',
        label: this.$t('general.peopleRegistrationInformation'),
        data: peopleDetailedInformation.values,
        showLine: true
      }]

      const { labels } = peopleDetailedInformation
      return { datasets, labels }
    },
    wereStatisticsFound () {
      return !(
        !this.statistics ||
        typeof this.statistics !== 'object' ||
        !Object.keys(this.statistics).length
      )
    }
  },
  created () {
    if (this.selectedApp.UUID) {
      this.$store.dispatch('getAppsStatistics')
    }
  },
  data () {
    return {
      datacollection: null,
      usersByDay: {
        datasets: [{
          backgroundColor: 'rgba(45, 206, 152, 0.3)',
          borderColor: '#2DCE98',
          label: this.$t('general.peoplePerDay'),
          data: [],
          showLine: true
        }],
        labels: []
      },
      usersByMonth: {
        datasets: [{
          backgroundColor: 'rgba(246, 98, 119, 0.3)',
          borderColor: '#F66277',
          label: this.$t('general.peoplePerMonth'),
          data: [],
          showLine: true
        }],
        labels: []
      },
      usersPerJourney: {
        datasets: [{
          backgroundColor: '#f3c788',
          borderColor: 'rgb(251, 99, 64)',
          label: this.$t('general.peoplePerJourneyStatus'),
          data: [],
          showLine: true
        }],
        labels: []
      },
      countriesData: [
        ['Country', 'Personas']
      ],
      countriesOptions: {
        colorAxis: { colors: ['#11CDEF', '#4279D6', '#172B4D'] },
        datalessRegionColor: '#F0F4FD',
        defaultColor: '#f5f5f5'
      },
      geoChartSettings: {
        packages: ['corechart', 'table'],
        mapsApiKey: 'AIzaSyBvLIBVDFF12w86Rj62B4lFxOS8GXvWhvI'
      }
    }
  },
  watch: {
    language () {
      this.usersByDay.datasets[0].label = this.$t('general.peoplePerDay')
      this.usersByMonth.datasets[0].label = this.$t('general.peoplePerMonth')
      this.usersPerJourney.datasets[0].label = this.$t('general.peoplePerJourneyStatus')
      this.$refs.lineChart1.renderChart(this.usersByDay, this.chartOptions)
      this.$refs.lineChart2.renderChart(this.usersByMonth, this.chartOptions)
      this.$refs.barChart.renderChart(this.usersPerJourney, this.chartOptions)
    },
    selectedApp (value) {
      if (value.UUID) {
        this.$store.dispatch('getAppsStatistics')
      }
    },
    toolbarDateRangeVisual (value) {
      let fromDate
      let toDate
      const getFullStatistics = value.allData

      if (typeof value === 'number') {
        fromDate = moment().subtract(value, 'days').format('YYYY-MM-DD')
        toDate = moment().format('YYYY-MM-DD')
      } else {
        fromDate = value.fromDate
        toDate = value.toDate
      }

      this.searchParams.fromDate = fromDate
      this.searchParams.toDate = toDate

      this.$store.commit('SET_SEARCH_PARAMS', { fromDate, toDate, getFullStatistics })
      this.$store.dispatch('getAppsStatistics')
    },
    statistics (value) {
      this.usersPerJourney.datasets[0].data = []
      this.usersPerJourney.labels = []
      this.usersByDay.datasets[0].data = []
      this.usersByDay.labels = []
      this.usersByMonth.datasets[0].data = []
      this.usersByMonth.labels = []
      this.countriesData = [
        ['Country', 'Personas']
      ]

      value.usersByDay.forEach(item => {
        this.usersByDay.datasets[0].data.unshift(item.count)
        this.usersByDay.labels.unshift(`${item.day}/${item.month}/${item.year}`)
      })

      value.usersByMonth.forEach(item => {
        this.usersByMonth.datasets[0].data.unshift(item.count)
        this.usersByMonth.labels.unshift(`${item.month}/${item.year}`)
      })

      value.journeysCount.forEach(item => {
        this.usersPerJourney.datasets[0].data.push(item.total)
        this.usersPerJourney.labels.push(item.name)
      })

      value.places.countries.forEach(item => {
        this.countriesData.push([item.location, item.count])
      })
    }
  }
}
</script>

<style scoped>
    .small {
        width: 100%;
        max-height: 100px;
    }
    .card-chart {
        border-radius: 10px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        padding: 10px;
    }
</style>
